// extracted by mini-css-extract-plugin
export default {"wrapper":"CollectionCard_wrapper__VrsYt","image":"CollectionCard_image__9uFKK"};